import {createSlice} from "@reduxjs/toolkit";

interface BroadcastState {
    isAdded: boolean,
    isUpdated: boolean
}

const initialState: BroadcastState = {
    isAdded: false,
    isUpdated: false
}

export const BroadcastSlice = createSlice({
    name: 'broadcast',
    initialState,
    reducers: {
        addBroadcast: (state, action) => {
            state.isAdded = action.payload;
        },
        updateBroadcast: (state, action) => {
            state.isUpdated = action.payload;
        }
    }
});

export const {addBroadcast, updateBroadcast} = BroadcastSlice.actions;
export default BroadcastSlice.reducer;
